/* eslint import/prefer-default-export: off */
import {
  SET_JACKPOT_TICKER,
  UPDATE_JACKPOT_TICKER,
  REMOVE_JACKPOT_TICKERS,
  SET_LIVECASINO_TICKER,
  UPDATE_LIVECASINO_TICKER,
  REMOVE_LIVECASINO_TICKERS,
  SET_BACCARAT_TICKER,
  REMOVE_BACCARAT_TICKERS,
} from './action_types';

export const setJackpotTicker = (data) => ({
  type: SET_JACKPOT_TICKER,
  data,
});

export const updateJackpotTicker = (data) => ({
  type: UPDATE_JACKPOT_TICKER,
  data,
});

export const removeJackpotTickers = (jackpotsIds) => ({
  type: REMOVE_JACKPOT_TICKERS,
  jackpotsIds,
});

export const setLivecasinoTicker = (data) => ({
  type: SET_LIVECASINO_TICKER,
  data,
});

export const updateLivecasinoTicker = (data) => ({
  type: UPDATE_LIVECASINO_TICKER,
  data,
});

export const removeLivecasinoTickers = (gamesIds) => ({
  type: REMOVE_LIVECASINO_TICKERS,
  gamesIds,
});

export const setBaccaratTicker = (data) => ({
  type: SET_BACCARAT_TICKER,
  data,
});

export const removeBaccaratTickers = (gamesIds) => ({
  type: REMOVE_BACCARAT_TICKERS,
  gamesIds,
});
